import { featureToggle } from "@faire/web/common/settings/declarations/featureToggle";

/**
 * Setting to control whether the product review count is fetched on the PDP.
 */
export const FE_ENABLE_FETCH_PRODUCT_REVIEW_COUNT_250630 = featureToggle({
  name: "FE_ENABLE_FETCH_PRODUCT_REVIEW_COUNT_250630",
  defaultValue: false,
  identifier: "RetailerTokenInSession",
  client: ["RETAILER", "VISITOR_WEB"],
  productArea: "PRODUCT_REVIEWS",
  notifyAfter: "2026-07-15",
});
